import e from"./RelevantSort.vue_vue&type=script&lang.js";import{render as t}from"./RelevantSort.vue_vue&type=template&id=257b248b&lang.js";e.render=t,e.__file="src/components/RelevantSort.vue";export default e;
//# sourceMappingURL=RelevantSort.vue.js.map
